/**
 * Flobi Home for this build: the one address every "Back to Flobi Home" in Artwork uses (the seat page, the
 * account menu, notification preferences), so local and staging builds never send people to two hosts.
 */
export const HOME_URL = ((import.meta.env.VITE_FLOBI_HOME_URL as string | undefined) || (import.meta.env.VITE_FLOBI_ADMIN_URL as string | undefined) || 'https://app.flobi.ai').replace(/\/+$/, '');
